import { combineReducers } from 'redux'

import userReducer from './user/user.reducer'
import cartReducer from './cart/cart.reducer'
import directoryReducer from './directory/directory.reducer'
import shopReducer from "./shop/shop.reducer";
import storeReducer from "./stores/stores.reducer";
import stateProductsReducer from "./stateproducts/stateproducts.reducer";
import categoryReducer from "./category/category.reducer";
import productsReducer from "./products/product.reducer";





import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['cart','user']
}

const rootReducer = combineReducers({
    user: userReducer,
    cart: cartReducer,
    directory: directoryReducer,
    shop: shopReducer,
    store:storeReducer,
    category:categoryReducer,
    stateProducts:stateProductsReducer,
    product:productsReducer
})

export default persistReducer(persistConfig, rootReducer)